// extracted by mini-css-extract-plugin
export default {"seller":"styles_seller__F5pme","avatar":"styles_avatar__IkdXh"};